import { IonContent, IonPage, IonList, IonItem, IonLabel, IonRadioGroup, IonRadio, IonInput, IonButton, useIonToast, IonCheckbox, IonModal, IonHeader, IonToolbar, IonTitle } from "@ionic/react"; // importar componentes Ionic para UI móvil
import Header from "src/components/Header"; // importar encabezado reutilizable
import React, { useMemo, useState } from "react"; // importar React y hooks para estado y cálculos
import Autocompleteoperario from "src/components/Autocompleteoperario"; // importar selector reutilizable de operarios
import Operarios from "src/services/operarios"; // importar servicio para consultar datos del operario
import LoginAPI from "src/services/login"; // importar servicio para obtener datos del usuario autenticado
import EvaluacionAPI from "src/services/evaluacion"; // importar servicio para crear/obtener evaluaciones
import { useHistory, useLocation } from "react-router-dom"; // navegar al detalle tras guardar y leer query string

// valores de la escala de respuestas
const OPCIONES = [ // definir arreglo con los valores de respuesta permitidos
  { label: "NUNCA", value: 1 }, // etiqueta y valor para nunca
  { label: "POCAS VECES", value: 2 }, // etiqueta y valor para pocas veces
  { label: "CASI SIEMPRE", value: 3 }, // etiqueta y valor para casi siempre
  { label: "SIEMPRE", value: 4 }, // etiqueta y valor para siempre
]; // fin arreglo de opciones

// listado de preguntas de responsabilidades/desempeño (OPERARIO según PDF)
const OPERARIO_RESP: string[] = [ // definir en orden las 9 preguntas solicitadas
  "Cumple diariamente su rutina en el tiempo establecido y con buena calidad.",
  "Conoce y aplica los procedimientos de limpieza establecidos.",
  "Informa en todos los casos, anticipadamente, a su superior inmediato sobre sus ausencias para poder cubrir su puesto.",
  "Mantiene su lugar de trabajo según las normas de 5 S",
  "Cumple con la política de imagen de El Mejor.",
  "Mantiene un buen ambiente de trabajo evitando los conflictos y los chismes.",
  "Utiliza las máquinas y/o elementos de limpieza adecuadamente.",
  "Cuando tiene alguna duda consulta a tiempo para realizar bien su trabajo.",
  "Ayuda con su buen trabajo al logro de la satisfacción del cliente.",
]; // fin preguntas de responsabilidad (operario)

// listado de preguntas de habilidades (OPERARIO según PDF)
const OPERARIO_HAB: string[] = [ // definir en orden las 8 preguntas solicitadas
  "Relación con el cliente interno, externo: saluda con cortesía y demuestra deseos de buscar su satisfacción.",
  "Responsabilidad: cumple con los horarios establecidos de entrada, salida y receso.",
  "Ética: actúa con honestidad y responsabilidad, cumpliendo con la conducta y valores de El Mejor.",
  "Trabajo en equipo: predisposición para trabajar con sus compañeros/as y supervisores/as con respeto.",
  "Apertura al Aprendizaje: acepta las sugerencias y las pone en práctica.",
  "Confidencialidad: evita comunicar a terceros sobre situaciones propias y reservadas.",
  "Disciplina: cumple y respeta políticas, normas, reglamentos y procedimientos de la empresa.",
  "Iniciativa: ante dificultades, trata de encontrar soluciones a su alcance sin acudir al supervisor/a.",
]; // fin preguntas de habilidades (operario)

// filas de indicadores de gestión
const FILAS_INDICADORES = [ // definir dos filas de indicadores
  { key: "montos", titulo: "Montos presupuestados por semana" }, // fila 1
  { key: "visitas", titulo: "Cantidad de visitas por semana" }, // fila 2
] as const; // marcar como constante para tipos literales

// catálogos de selección múltiple (hasta 3) para resúmenes
const FORTALEZAS_OPCIONES = [ // opciones para fortalezas
  { id: 1, label: "Trabajo en equipo" }, // item 1
  { id: 2, label: "Puntualidad y asistencia" }, // item 2
  { id: 3, label: "Atención al detalle" }, // item 3
  { id: 4, label: "Compromiso con los procedimientos de seguridad" }, // item 4
  { id: 5, label: "Actitud positiva hacia el trabajo" }, // item 5
  { id: 6, label: "Calidad en la ejecución de tareas" }, // item 6
  { id: 7, label: "Comunicación efectiva con el equipo" }, // item 7
  { id: 8, label: "Adaptabilidad a cambios" }, // item 8
  { id: 9, label: "Iniciativa para resolver problemas" }, // item 9
] as const; // fin fortalezas

const OPORTUNIDADES_OPCIONES = [ // opciones para oportunidades de mejora
  { id: 1, label: "Mejora en la puntualidad y asistencia" }, // item 1
  { id: 2, label: "Mayor atención al detalle en tareas" }, // item 2
  { id: 3, label: "Cumplimiento de normas y procedimientos de seguridad" }, // item 3
  { id: 4, label: "Mejora en la comunicación con compañeros, supervisores y/o fiscales" }, // item 4
  { id: 5, label: "Capacidad de adaptarse a los cambios" }, // item 5
  { id: 6, label: "Manejo del tiempo y productividad" }, // item 6
  { id: 7, label: "Reducción de errores en el trabajo" }, // item 7
  { id: 8, label: "Mayor participación en el trabajo en equipo" }, // item 8
  { id: 9, label: "Iniciativa para resolver problemas" }, // item 9
] as const; // fin oportunidades

const CAPACITACIONES_OPCIONES = [ // opciones para sugerencias de capacitaciones
  { id: 1, label: "Capacitación en seguridad y manejo de herramientas" }, // item 1
  { id: 2, label: "Mejora en técnicas de limpieza/procesos" }, // item 2
  { id: 3, label: "Comunicación efectiva" }, // item 3
  { id: 4, label: "Trabajo en equipo y colaboración" }, // item 4
  { id: 5, label: "Gestión del tiempo" }, // item 5
  { id: 6, label: "Atención al cliente" }, // item 6
  { id: 7, label: "Adaptación a nuevos procedimientos y cambios" }, // item 7
  { id: 8, label: "Solución de problemas y toma de decisiones" }, // item 8
] as const; // fin capacitaciones

// preguntas específicas para SUPERVISOR (según formato provisto)
const SUPERVISOR_RESP: string[] = [
  "Es ejemplo para los colaboradores a su cargo, cumpliendo con las normas y procedimientos",
  "Cumple las responsabilidades propias del cargo",
  "Utiliza las herramientas informáticas (planillas electrónicas, planillas de texto, app, sistemas informáticos)",
  "Realiza sus tareas teniendo en cuenta los Procedimientos Operativos de Calidad",
  "Mantiene su lugar de trabajo según las normas de 5 S",
  "Tiene un manejo confidencial de las informaciones recibidas",
  "Supervisa tareas, reconociendo y sancionando al personal a su cargo, de acuerdo a las políticas y reglamento interno de la empresa",
  "Se relaciona adecuadamente con las personas a su cargo, manteniendo un trato profesional y de respeto",
  "Mantiene informados adecuadamente a sus superiores respecto a las actividades generales del servicio",
  "Resuelve las consultas que fueran necesarias en el momento oportuno para el logro de los objetivos",
  "Posee los conocimientos técnicos actuales para desempeñarse en el cargo",
  "Capacita al personal a su cargo en coordinación con el responsable de Área y/o Gestión de Talento",
]; // fin responsabilidades supervisor

const SUPERVISOR_HAB: string[] = [
  "Relación con el cliente interno, externo: muestra predisposición para servir a clientes y colaboradores, buscando comprender y satisfacer sus necesidades",
  "Tolerancia a la presión: resuelve los problemas de forma objetiva sin dejarse afectar por situaciones que afecten el curso normal de las actividades",
  "Asertividad: realiza retroalimentación positiva o de oportunidades de mejora a sus colaboradores, de forma oportuna y objetiva",
  "Trabajo en equipo: orienta la acción de sus colaboradores con el fin de lograr la interacción y trabajo en conjunto entre los miembros",
  "Apertura al Aprendizaje: motiva permanentemente a sus colaboradores a que se formen a través de charlas o capacitaciones",
  "Planificación: planifica de forma eficaz su trabajo y el de sus colaboradores con el fin de alcanzar los objetivos esperados",
  "Capacidad crítica: evalúa la información, datos y líneas de acción para conseguir decisiones lógicas de forma imparcial y razonada",
  "Flexibilidad: realiza los cambios necesarios en función a los nuevos retos o necesidades del entorno",
  "Delegación: distribuye y asigna tareas y funciones a las personas adecuadas",
  "Orientación a Resultados: realiza todas las acciones necesarias para alcanzar los objetivos establecidos",
  "Coordinación: establece claramente directivas, fija objetivos y prioridades, y los comunica",
  "Liderazgo: influye de manera positiva en las personas a su cargo con el fin de guiarlos hacia los objetivos de la empresa",
]; // fin habilidades supervisor

// componente principal
const EvaluacionDesempeno: React.FC = () => { // declarar componente funcional
  // estado: datos de cabecera
  const [evaluado, setEvaluado] = useState<{ id: string; usuario: string; cargo: string } | null>(null); // seleccionado a evaluar
  const [fechaIngreso, setFechaIngreso] = useState<string>(""); // fecha de ingreso del evaluado
  const [evaluadorNombre, setEvaluadorNombre] = useState<string>(""); // nombre del evaluador (desde sesión)
  const [evaluadorCargo, setEvaluadorCargo] = useState<string>(""); // cargo del evaluador (desde sesión)
  const [evaluadorId, setEvaluadorId] = useState<number | null>(null); // cédula del evaluador (desde sesión)
  const [present] = useIonToast(); // hook de toast para feedback
  const history = useHistory(); // hook de navegación
  const location = useLocation(); // ubicación actual para leer parámetros
  const [paso, setPaso] = useState<number>(1); // paso actual del cuestionario (1: Resp, 2: Hab, 3: Indic, 4: Resumen)
  const [indicadoresNoAplica, setIndicadoresNoAplica] = useState<{ montos: boolean; visitas: boolean }>({ montos: false, visitas: false }); // flags por indicador
  const [mostrarModalFirmas, setMostrarModalFirmas] = useState<boolean>(false); // controlar modal de firmas
  const canvasEvalRef = React.useRef<HTMLCanvasElement | null>(null); // referencia al canvas del evaluador
  const canvasEvadoRef = React.useRef<HTMLCanvasElement | null>(null); // referencia al canvas del evaluado
  const [firmas, setFirmas] = useState<{ evaluador?: string; evaluado?: string }>({}); // almacenar firmas en base64
  const [dibujando, setDibujando] = useState<{ eval: boolean; evado: boolean }>({ eval: false, evado: false }); // estado de dibujo
  const [firmaPaso, setFirmaPaso] = useState<1 | 2>(1); // 1: firma evaluador, 2: firma evaluado
  const [tipoEval, setTipoEval] = React.useState<'operario' | 'supervisor'>('operario'); // tipo de evaluación actual controlado por estado

  // control de cancelación y debounce para la consulta de capacitaciones
  const abortCapRef = React.useRef<AbortController | null>(null); // referencia al AbortController para cancelar la última request
  const debounceRef = React.useRef<any>(null); // referencia al timeout para aplicar debounce

  // estado de selección múltiple: fortalezas (ids) + "Otra"
  const [fortalezasSel, setFortalezasSel] = useState<number[]>([]); // ids seleccionados de fortalezas
  const [fortalezasOtra, setFortalezasOtra] = useState<boolean>(false); // si se marcó "Otra"
  const [fortalezasOtraTxt, setFortalezasOtraTxt] = useState<string>(""); // texto de "Otra"

  // estado de selección múltiple: oportunidades (ids) + "Otra"
  const [oportSel, setOportSel] = useState<number[]>([]); // ids seleccionados de oportunidades
  const [oportOtra, setOportOtra] = useState<boolean>(false); // si se marcó "Otra"
  const [oportOtraTxt, setOportOtraTxt] = useState<string>(""); // texto de "Otra"

  // estado de selección múltiple: capacitaciones (ids) + "Otra"
  const [capSel, setCapSel] = useState<number[]>([]); // ids seleccionados de capacitaciones
  const [capOtra, setCapOtra] = useState<boolean>(false); // si se marcó "Otra"
  const [capOtraTxt, setCapOtraTxt] = useState<string>(""); // texto de "Otra"

  // indicadores para OPERARIO: cantidad y puntos por mapeo
  const [indicOper, setIndicOper] = useState<{ sanciones: string }>( // estado simple para inputs (solo sanciones)
    () => ({ sanciones: "" })
  ); // fin estado indicadores operario
  const [evalId, setEvalId] = useState<number | null>(null); // id de la evaluación cuando se ingresa en modo edición/borrador
  const contentRef = React.useRef<HTMLIonContentElement | null>(null); // referencia al IonContent para controlar el scroll

  // cargar datos del evaluador desde la sesión
  React.useEffect(() => { // efecto al montar
    LoginAPI.me().then(({ data }) => { // consultar endpoint de usuario
      const u = data?.datos || {}; // extraer datos
      setEvaluadorNombre(String(u.emp_nombre || "")); // setear nombre legible
      setEvaluadorCargo(String(u.emp_cargo || "")); // setear cargo
      setEvaluadorId(Number(u.emp_cedula || 0) || null); // setear cédula si existe
    }).catch(() => { /* sin bloqueo si falla */ }); // no interrumpir si falla
  }, []); // sin dependencias

  React.useEffect(() => { // detectar si se ingresó con un id de evaluación para edición/continuación
    const qs = new URLSearchParams(location.search); // leer parámetros de la URL
    const idStr = (qs.get('id') || "").trim(); // obtener id como string normalizado
    const idNum = Number(idStr); // convertir a número
    setEvalId(Number.isFinite(idNum) && idNum > 0 ? idNum : null); // guardar id válido o null
  }, [location.search]); // recalcular cuando cambie la URL

  React.useEffect(() => { // cargar datos desde el backend cuando hay un evalId válido
    const cargar = async () => { // función asincrónica de carga
      if (!evalId) return; // si no hay id válido no hacer nada
      try {
        const data = await EvaluacionAPI.obtener(evalId); // obtener evaluación completa desde backend
        const cab = data?.cabecera || {}; // extraer cabecera o dict vacío
        const respSrv = (data?.respuestas?.responsabilidades || []) as number[]; // arreglo de respuestas de responsabilidades
        const habSrv = (data?.respuestas?.habilidades || []) as number[]; // arreglo de respuestas de habilidades

        // inferir tipo de evaluación en base a la cantidad de preguntas respondidas
        const esSupervisor = respSrv.length === SUPERVISOR_RESP.length && habSrv.length === SUPERVISOR_HAB.length; // comparar longitudes con catálogo de supervisor
        setTipoEval(esSupervisor ? 'supervisor' : 'operario'); // fijar tipo de evaluación según resultado

        // setear evaluado en el header usando servicio de operarios
        try {
          const detEval = await Operarios.obtenerPorId(cab.evaluado_id).catch(() => null); // obtener datos del evaluado por id
          if (detEval) { // si hay datos
            setEvaluado({ id: String(cab.evaluado_id), usuario: String(detEval.nombre || detEval.usuario || ""), cargo: String(detEval.cargo || "") }); // actualizar estado de evaluado
            const fi = detEval?.fecha_ingreso || detEval?.fechaIngreso || cab?.fecha_ingreso || ""; // elegir fecha de ingreso disponible
            setFechaIngreso(fi ? String(fi) : ""); // setear fecha de ingreso si existe
          } else {
            setEvaluado({ id: String(cab.evaluado_id || ""), usuario: "", cargo: "" }); // fallback mínimo con solo id
          }
        } catch {
          setEvaluado({ id: String(cab.evaluado_id || ""), usuario: "", cargo: "" }); // fallback si falla la consulta
        }

        // poblar respuestas en el estado local
        if (respSrv.length > 0) { // si el backend devolvió respuestas de responsabilidades
          setRespuestasResp(respSrv.map(v => Number(v) || 0)); // copiar valores normalizados al estado
        }
        if (habSrv.length > 0) { // si el backend devolvió respuestas de habilidades
          setRespuestasHab(habSrv.map(v => Number(v) || 0)); // copiar valores normalizados al estado
        }

        // poblar indicadores numéricos desde backend (si existen); la lógica dinámica (sanciones/capacitaciones)
        // seguirá recalculándose vía efectos asociados al cambio de evaluado
        const ind = data?.indicadores || {}; // extraer indicadores o dict vacío
        const indMontos = ind.montos || {}; // indicador de montos
        const indVisitas = ind.visitas || {}; // indicador de visitas
        setIndicadores({ // actualizar estado de indicadores
          montos: {
            objetivo: indMontos.objetivo !== undefined ? String(indMontos.objetivo) : "", // objetivo montos como texto
            cantidad: indMontos.cantidad !== undefined ? String(indMontos.cantidad) : "", // cantidad montos como texto
          },
          visitas: {
            objetivo: indVisitas.objetivo !== undefined ? String(indVisitas.objetivo) : "", // objetivo visitas
            cantidad: indVisitas.cantidad !== undefined ? String(indVisitas.cantidad) : "", // cantidad visitas
          },
        });
      } catch { 
        // en caso de error al cargar, dejamos el formulario en blanco; el usuario podrá iniciar una nueva evaluación
      }
    };
    cargar(); // ejecutar carga
  }, [evalId]); // dependencias: recargar cuando cambie evalId

  // al seleccionar evaluado buscar su fecha de ingreso si la API lo provee
  const onSeleccionarEvaluado = async (op: { id: string; usuario: string; cargo: string } | null) => { // handler de cambio
    setEvaluado(op); // actualizar evaluado
    setFechaIngreso(""); // limpiar valor previo
    if (op && op.id) { // si hay id válido
      const detalle = await Operarios.obtenerPorId(op.id).catch(() => null); // consultar detalle
      const fi = detalle?.fecha_ingreso || detalle?.fechaIngreso || ""; // admitir variantes de nombre
      setFechaIngreso(fi ? String(fi) : ""); // setear si existe

      // Autocompletar Capacitaciones (solo para evaluaciones de Supervisor)
      try {
        const tipo = tipoEval; // leer tipo actual desde el estado controlado
        if (tipo === 'supervisor') { // aplicar solo para supervisor
          // cancelar request anterior si está en curso
          if (abortCapRef.current) { try { abortCapRef.current.abort(); } catch (_) {} } // abortar silenciosamente
          // limpiar debounce anterior si existía
          if (debounceRef.current) { clearTimeout(debounceRef.current); } // limpiar timeout pendiente
          // crear nuevo controller para esta solicitud
          const controller = new AbortController(); // instanciar AbortController
          abortCapRef.current = controller; // guardar referencia activa
          // aplicar debounce de 300ms antes de llamar
          debounceRef.current = setTimeout(async () => { // programar ejecución diferida
            try {
              const anio = new Date().getFullYear(); // obtener año actual calendario
              const resp = await EvaluacionAPI.obtenerCapacitacionesAnuales(
                Number(op.id), // id del empleado
                anio, // año actual
                false, // sin detalle
                { timeoutMs: 60000 } // configurar timeout extendido
              ); // consultar API
              const cant = Number(resp?.datos?.cantidad || 0); // extraer cantidad con fallback 0
              setIndicadorSupervisor('cantidad', String(cant)); // setear cantidad en el indicador
            } catch (e: any) {
              if (e?.name === 'CanceledError' || e?.message === 'canceled' || e?.code === 'ERR_CANCELED') { return; } // no hacer nada si se canceló
              setIndicadorSupervisor('cantidad', '0'); // fallback en error/timeout
            }
          }, 300); // 300ms de debounce
        } // fin if tipo supervisor
      } catch { 
        // si falla la configuración del flujo, colocar 0 para no bloquear la UI
        setIndicadorSupervisor('cantidad', '0'); // fallback
      }

      // Autocompletar Sanciones (solo para evaluaciones de Operario)
      try { // abrir bloque con manejo de errores
        const tipo = tipoEval; // leer tipo actual desde el estado
        if (tipo === 'operario') { // aplicar únicamente para operario
          const anio = new Date().getFullYear(); // obtener el año calendario actual
          const resp = await EvaluacionAPI.obtenerSancionesAnuales( // invocar servicio de sanciones
            Number(op.id), // enviar id/legajo del empleado seleccionado
            anio, // año de consulta
            false, // sin detalle para esta carga automática
            { timeoutMs: 30000 } // timeout extendido
          ); // fin invocación
          const cant = Number(resp?.datos?.cantidad || 0); // extraer cantidad de sanciones con fallback seguro
          setIndicOper(prev => ({ ...prev, sanciones: String(cant) })); // escribir cantidad en el estado del indicador
        } // fin if tipo
      } catch { // capturar cualquier error sin bloquear la UI
        setIndicOper(prev => ({ ...prev, sanciones: "0" })); // fallback en caso de error o timeout
      } // fin try-catch
    } // fin if
  }; // fin handler

  // estado de respuestas de responsabilidades
  const [respuestasResp, setRespuestasResp] = useState<number[]>( // crear estado con números por respuesta
    () => Array(OPERARIO_RESP.length).fill(0) // inicializar con base en Operario por defecto
  ); // fin estado

  // estado de respuestas de habilidades
  const [respuestasHab, setRespuestasHab] = useState<number[]>( // crear estado con números por respuesta
    () => Array(OPERARIO_HAB.length).fill(0) // inicializar con base en Operario por defecto
  ); // fin estado

  // estado de indicadores: objetivo y cantidad por fila
  const [indicadores, setIndicadores] = useState<Record<string, { objetivo: string; cantidad: string }>>( // estado para inputs numéricos como texto
    () => ({ // inicializar objeto por cada fila
      montos: { objetivo: "", cantidad: "" }, // estado inicial para montos
      visitas: { objetivo: "", cantidad: "" }, // estado inicial para visitas
    }) // fin objeto inicial
  ); // fin estado indicadores



  // helpers de cálculo seguros
  const toNumber = (v: string): number => { // convertir cadena a número controlando vacíos
    const n = Number(v); // intentar convertir
    return isFinite(n) ? n : 0; // si no es finito devolver 0
  }; // fin helper

  const clamp = (v: number, min = 0, max = 100): number => { // limitar valores a un rango
    return Math.max(min, Math.min(max, v)); // aplicar límites inferiores y superiores
  }; // fin clamp

  const fmt2 = (v: number): string => { // formatear a 2 decimales
    return Number.isFinite(v) ? v.toFixed(2) : "0.00"; // devolver con dos decimales
  }; // fin formateador



  // cálculos de responsabilidades
  const totalPosibleResp = useMemo(() => { // total máximo de puntos para responsabilidades
    const len = tipoEval === 'supervisor' ? SUPERVISOR_RESP.length : OPERARIO_RESP.length; // longitud según tipo actual
    return len * 4; // total máximo
  }, [tipoEval]); // depender del tipo actual
  const puntosResp = useMemo( // sumar puntos marcados en responsabilidades
    () => respuestasResp.reduce((acc, v) => acc + (Number(v) || 0), 0), // acumular valores válidos
    [respuestasResp] // recalcular cuando cambien
  ); // fin cálculo
  const porcentajeResp = useMemo( // porcentaje de responsabilidades
    () => (totalPosibleResp ? (puntosResp / totalPosibleResp) * 100 : 0), // dividir por total si es >0
    [puntosResp, totalPosibleResp] // dependencias
  ); // fin porcentaje

  // cálculos de habilidades
  const totalPosibleHab = useMemo(() => { // total máximo de puntos para habilidades
    const len = tipoEval === 'supervisor' ? SUPERVISOR_HAB.length : OPERARIO_HAB.length; // longitud según tipo actual
    return len * 4; // total máximo
  }, [tipoEval]); // depender del tipo actual
  const puntosHab = useMemo( // sumar puntos marcados en habilidades
    () => respuestasHab.reduce((acc, v) => acc + (Number(v) || 0), 0), // suma robusta
    [respuestasHab] // dependencia de las respuestas
  ); // fin cálculo
  const porcentajeHab = useMemo( // porcentaje de habilidades
    () => (totalPosibleHab ? (puntosHab / totalPosibleHab) * 100 : 0), // dividir evitando cero
    [puntosHab, totalPosibleHab] // dependencias
  ); // fin porcentaje

  // cálculos de indicadores por fila
  const indicadoresCalc = useMemo(() => { // calcular porcentajes/puntuación por indicador
    const res: Record<string, { porcentaje: number; puntuacion: number }> = {}; // objeto de resultados
    for (const fila of FILAS_INDICADORES) { // iterar por filas definidas
      const obj = toNumber(indicadores[fila.key].objetivo); // convertir objetivo a número
      const cant = toNumber(indicadores[fila.key].cantidad); // convertir cantidad a número
      const porc = obj > 0 ? clamp((cant / obj) * 100) : 0; // calcular porcentaje limitado 0..100 evitando división por cero
      res[fila.key] = { porcentaje: porc, puntuacion: porc }; // asignar porcentaje y misma puntuación
    } // fin for
    return res; // devolver resultados
  }, [indicadores]); // recalcular si cambian los inputs

  const totalPosibleIndic = useMemo(() => { // total máximo según tipo de evaluación
    const tipo = tipoEval; // leer tipo actual desde el estado controlado
    if (tipo === 'supervisor') return 100; // supervisor: solo se considera el indicador de capacitaciones (máx. 100 puntos)
    // Operario: solo sanciones con mapeo a puntos 0..3, por lo que el total posible es 3
    return 3; // devolver total posible para operario
  }, [tipoEval]); // dependencias del cálculo





  // totales por bloque (competencias requeridas) - se declara más abajo tras puntosIndic

  // puntaje final se declara más abajo tras 'totales'

  // manejadores de cambio
  const setResp = (idx: number, value: number) => { // actualizar respuesta de responsabilidades
    setRespuestasResp(prev => { // usar forma de función para estado previo
      const next = [...prev]; // copiar arreglo para no mutar
      next[idx] = value; // asignar nuevo valor seleccionado
      return next; // devolver nuevo estado
    }); // fin actualización
  }; // fin setResp

  const setHab = (idx: number, value: number) => { // actualizar respuesta de habilidades
    setRespuestasHab(prev => { // usar updater
      const next = [...prev]; // copiar arreglo
      next[idx] = value; // asignar valor
      return next; // devolver nuevo estado
    }); // fin actualización
  }; // fin setHab

  const setIndicador = (key: string, campo: "objetivo" | "cantidad", valor: string) => { // actualizar inputs de indicadores
    setIndicadores(prev => ({ // actualizar de forma inmutable
      ...prev, // copiar resto de claves
      [key]: { ...prev[key], [campo]: valor.replace(",", ".") }, // actualizar campo convirtiendo coma a punto
    })); // fin set
  }; // fin setIndicador

  // indicadores para SUPERVISOR: solo capacitaciones realizadas en el periodo
  const [indicSup, setIndicSup] = useState<{ capacitaciones: { objetivo: string; cantidad: string } }>( // estado de indicadores para supervisor
    () => ({ capacitaciones: { objetivo: "", cantidad: "" } }) // estado inicial sin datos
  ); // estado específico para supervisor

  const setIndicadorSupervisor = (campo: "objetivo" | "cantidad", valor: string) => { // actualizar indicador de capacitaciones
    setIndicSup(prev => ({ // usar forma funcional para trabajar con el estado previo
      capacitaciones: { // mantener un único indicador de capacitaciones
        ...prev.capacitaciones, // copiar valores actuales
        [campo]: String(valor).replace(",", "."), // actualizar campo normalizando el separador decimal
      }, // fin objeto de capacitaciones
    })); // fin actualización de estado
  }; // fin setIndicadorSupervisor

  const indicSupCalc = useMemo(() => { // cálculo de porcentajes/puntuación para supervisor (solo capacitaciones)
    const toNum = (v: string) => { const n = Number(v); return isFinite(n) ? n : 0; }; // helper local de conversión segura
    const cObj = toNum(indicSup.capacitaciones.objetivo); // objetivo de capacitaciones anuales
    const cCan = toNum(indicSup.capacitaciones.cantidad); // cantidad de capacitaciones realizadas
    const cPorc = cObj > 0 ? clamp((cCan / cObj) * 100) : 0; // porcentaje directo de cumplimiento limitado 0..100
    const cPunt = cPorc; // en esta versión la puntuación coincide con el porcentaje

    return { capacitaciones: { porcentaje: cPorc, puntuacion: cPunt } }; // devolver estructura calculada
  }, [indicSup]); // recalcular cuando cambien los indicadores del supervisor

  // puntos por indicadores según tipo (colocado tras cálculos específicos)
  const puntosIndic = useMemo(() => { // sumar puntuaciones considerando el tipo de evaluación
    const tipo = tipoEval; // leer tipo actual desde el estado
    if (tipo === 'supervisor') { // supervisor: solo usa el indicador de capacitaciones
      return indicSupCalc.capacitaciones.puntuacion || 0; // devolver puntuación de capacitaciones
    }
    // Operario: mapear cantidad de sanciones a puntos (0->3, 1->2, 2->1, >=3->0)
    const mapPts = (n: number) => (n === 0 ? 3 : n === 1 ? 2 : n === 2 ? 1 : 0); // función de mapeo de sanciones a puntos
    const sanc = mapPts(Number((indicOper as any)?.sanciones || 0)); // calcular puntaje en base a sanciones
    return sanc; // devolver puntaje
  }, [location.search, indicSupCalc, indicOper]); // dependencias

  const porcentajeIndic = useMemo(() => (totalPosibleIndic ? (puntosIndic / totalPosibleIndic) * 100 : 0), [puntosIndic, totalPosibleIndic]); // porcentaje condicionado

  // totales por bloque (competencias requeridas)
  const totales = useMemo(() => { // consolidar totales y alcanzados por sección
    return { // devolver objeto con los tres bloques
      responsabilidad: { total: totalPosibleResp, alcanzado: puntosResp, porcentaje: porcentajeResp }, // bloque de responsabilidades
      habilidades: { total: totalPosibleHab, alcanzado: puntosHab, porcentaje: porcentajeHab }, // bloque de habilidades
      indicadores: { total: totalPosibleIndic, alcanzado: puntosIndic, porcentaje: porcentajeIndic }, // bloque de indicadores
    }; // fin objeto
  }, [totalPosibleResp, puntosResp, porcentajeResp, totalPosibleHab, puntosHab, porcentajeHab, totalPosibleIndic, puntosIndic, porcentajeIndic]); // dependencias

  // puntaje final
  const puntajeFinal = useMemo(() => { // calcular el resumen final
    const total = totales.responsabilidad.total + totales.habilidades.total + totales.indicadores.total; // sumar puntos totales
    const alcanzado = totales.responsabilidad.alcanzado + totales.habilidades.alcanzado + totales.indicadores.alcanzado; // sumar alcanzados
    const porcentaje = total ? (alcanzado / total) * 100 : 0; // calcular porcentaje final
    return { total, alcanzado, porcentaje }; // devolver estructura
  }, [totales]); // recalcular cuando cambien totales
  // Guardar evaluación en backend
  const puedeGuardar = useMemo(() => { // validar que todo esté completo (para finalizar)
    const todasResp = respuestasResp.every(v => v >= 1 && v <= 4); // verificar que todas las respuestas de responsabilidades estén completas
    const todasHab  = respuestasHab.every(v => v >= 1 && v <= 4); // verificar que todas las respuestas de habilidades estén completas
    const maxSel = tipoEval === 'operario' ? 3 : 5; // máximo por sección según tipo (operario=3, supervisor=5)
    // validar selección múltiple: al menos 1 y máximo según tipo (incluyendo "Otra")
    const countFort = fortalezasSel.length + (fortalezasOtra ? 1 : 0);
    const countOpor = oportSel.length + (oportOtra ? 1 : 0);
    const countCap  = capSel.length + (capOtra ? 1 : 0);
    const resumenOK = // bandera de validez de selección múltiple
      countFort >= 1 && countFort <= maxSel &&
      countOpor >= 1 && countOpor <= maxSel &&
      countCap  >= 1 && countCap  <= maxSel &&
      (!fortalezasOtra || fortalezasOtraTxt.trim().length > 0) &&
      (!oportOtra || oportOtraTxt.trim().length > 0) &&
      (!capOtra || capOtraTxt.trim().length > 0); // validar texto si "Otra" está marcada
    const indOK = tipoEval === 'supervisor' // validar indicadores solo para supervisor
      ? (Number(indicSup.capacitaciones.objetivo) > 0 && Number(indicSup.capacitaciones.cantidad) >= 0) // supervisor: objetivo > 0 y cantidad no negativa
      : true; // operario: siempre OK respecto a indicadores

    return Boolean(evaluado && todasResp && todasHab && resumenOK && indOK); // indicadores pueden quedar en 0
  }, [evaluado, respuestasResp, respuestasHab, fortalezasSel, fortalezasOtra, fortalezasOtraTxt, oportSel, oportOtra, oportOtraTxt, capSel, capOtra, capOtraTxt, tipoEval, indicSup]);

  const puedeGuardarBorrador = useMemo(() => { // validar datos mínimos para guardar como EN_PROCESO
    return Boolean(evaluado); // para borrador solo exigimos tener un evaluado seleccionado
  }, [evaluado]);

  const irArriba = () => { // llevar el scroll al inicio del contenido
    try {
      const el = contentRef.current; // obtener referencia al IonContent
      if (el && typeof (el as any).scrollToTop === 'function') { // verificar disponibilidad de scrollToTop
        (el as any).scrollToTop(300); // animar scroll al tope en 300ms
      } else if (el && el.scrollTo) { // fallback estándar de scroll
        el.scrollTo({ top: 0, behavior: 'smooth' }); // desplazar suavemente hacia arriba
      }
    } catch {
      // si falla el scroll, se ignora silenciosamente para no romper la UX
    }
  };

  const construirPayloadBase = () => { // armar el payload común para crear/actualizar evaluaciones
    return { // devolver estructura base compatible con el backend
      evaluado_id: Number(evaluado?.id), // id del evaluado seleccionado
      evaluador_id: evaluadorId || undefined, // cedula del evaluador (si se omite el backend usa usuario de sesión)
      evaluador_cargo: evaluadorCargo || undefined, // cargo del evaluador o valor por defecto desde sesión
      fecha_ingreso: fechaIngreso || undefined, // fecha de ingreso en formato YYYY-MM-DD si está presente
      respuestas: { // bloque de respuestas
        responsabilidades: respuestasResp, // arreglo con respuestas de responsabilidades
        habilidades: respuestasHab, // arreglo con respuestas de habilidades
      },
      indicadores: { // bloque de indicadores cuantitativos
        montos: {
          objetivo: toNumber(indicadores.montos.objetivo), // convertir objetivo de montos a número
          cantidad: toNumber(indicadores.montos.cantidad), // convertir cantidad de montos a número
        },
        visitas: {
          objetivo: toNumber(indicadores.visitas.objetivo), // convertir objetivo de visitas a número
          cantidad: toNumber(indicadores.visitas.cantidad), // convertir cantidad de visitas a número
        },
      },
      indicadores_no_aplica: indicadoresNoAplica, // indicar si algún indicador no aplica
      resumenes_seleccion: { // enviar estructura de selección múltiple (el backend puede ignorarla por ahora)
        fortalezas_ids: fortalezasSel, // ids de fortalezas
        oportunidades_ids: oportSel, // ids de oportunidades
        capacitaciones_ids: capSel, // ids de capacitaciones
        otros: { // textos de "Otra" si aplican
          ...(fortalezasOtra ? { fortalezas: fortalezasOtraTxt.trim() } : {}), // incluir si se marcó
          ...(oportOtra ? { oportunidades: oportOtraTxt.trim() } : {}), // incluir si se marcó
          ...(capOtra ? { capacitaciones: capOtraTxt.trim() } : {}), // incluir si se marcó
        },
      },
    };
  };

  const onGuardarBorrador = async () => { // handler para guardar la evaluación como EN_PROCESO (borrador)
    if (!puedeGuardarBorrador) { // validar datos mínimos
      present({ message: 'Seleccioná un evaluado antes de guardar en proceso.', duration: 2500, color: 'warning' }); // mostrar advertencia
      return; // salir sin llamar al backend
    }
    try {
      const base = construirPayloadBase(); // construir el payload común
      const payload = { ...base, borrador: true } as any; // marcar como borrador para que el backend lo guarde con estado EN_PROCESO
      let res: any; // variable para almacenar la respuesta del backend
      if (evalId) { // si ya existe un id de evaluación, actualizar el borrador existente
        res = await EvaluacionAPI.actualizar(evalId, payload); // actualizar evaluación en proceso
      } else {
        res = await EvaluacionAPI.crear(payload); // crear borrador nuevo (id se obtendrá de la respuesta)
        if (res?.id) { // si el backend devolvió un id válido
          setEvalId(Number(res.id)); // guardar id en estado para futuras actualizaciones
        }
      }
      present({ message: `Evaluación guardada en proceso. ID ${res?.id ?? evalId ?? ''}`, duration: 3000, color: 'success' }); // notificar éxito
    } catch (e: any) {
      const msg = e?.response?.data?.error || 'No se pudo guardar la evaluación en proceso'; // mensaje de error del backend o texto genérico
      present({ message: msg, duration: 3000, color: 'danger' }); // mostrar error
    }
  };

  const onGuardar = async () => { // handler para enviar al backend como evaluación finalizada
    if (!puedeGuardar) {
      const maxSel = tipoEval === 'operario' ? 3 : 5; // máximo de selecciones por sección según tipo
      present({ message: `Completá todas las respuestas y las selecciones (máx. ${maxSel} por sección).`, duration: 2500, color: 'warning' }); // advertencia de validación
      return;
    }

    // si faltan firmas, abrir modal para capturarlas
    if (!firmas.evaluador || !firmas.evaluado) {
      setFirmaPaso(1); // asegurar que siempre se inicie por la firma del evaluador
      setMostrarModalFirmas(true);
      return;
    }
    await guardarFinalConFirmas({ evaluador: firmas.evaluador, evaluado: firmas.evaluado });
  };

  const guardarFinalConFirmas = async (firmasFinal: { evaluador: string; evaluado: string }) => {
    try {
      const base = construirPayloadBase(); // reutilizar payload base
      const payload = {
        ...base,
        firmas: { evaluador_b64: firmasFinal.evaluador, evaluado_b64: firmasFinal.evaluado },
        borrador: false,
      } as any;
      let res: any;
      if (evalId) {
        res = await EvaluacionAPI.actualizar(evalId, payload);
      } else {
        res = await EvaluacionAPI.crear(payload);
      }

      // reset de formulario a estado inicial
      setEvaluado(null);
      setFechaIngreso("");
      const lenResp = tipoEval === 'supervisor' ? SUPERVISOR_RESP.length : OPERARIO_RESP.length;
      const lenHab  = tipoEval === 'supervisor' ? SUPERVISOR_HAB.length  : OPERARIO_HAB.length;
      setRespuestasResp(Array(lenResp).fill(0));
      setRespuestasHab(Array(lenHab).fill(0));
      setIndicadores({ montos: { objetivo: "", cantidad: "" }, visitas: { objetivo: "", cantidad: "" } });
      setIndicSup({ capacitaciones: { objetivo: "", cantidad: "" } });
      setFortalezasSel([]); setFortalezasOtra(false); setFortalezasOtraTxt("");
      setOportSel([]); setOportOtra(false); setOportOtraTxt("");
      setCapSel([]); setCapOtra(false); setCapOtraTxt("");
      setFirmas({}); setPaso(1);

      present({
        message: `Evaluación guardada. ID ${res?.id ?? ''}`,
        duration: 3500,
        color: 'success',
        buttons: [
          {
            text: 'Ver',
            handler: () => {
              if (res?.id) history.push(`/evaluacion-de-desempeno/${res.id}`);
            },
          },
          { text: 'OK', role: 'cancel' },
        ],
      });
    } catch (e: any) {
      const msg = e?.response?.data?.error || 'No se pudo guardar la evaluación';
      present({ message: msg, duration: 3000, color: 'danger' });
    }
  };

  // utilidades de firma
  const limpiarFirma = (tipo: 'eval' | 'evado') => { // limpiar canvas según tipo
    const cv = tipo === 'eval' ? canvasEvalRef.current : canvasEvadoRef.current;
    if (!cv) return;
    const ctx = cv.getContext('2d');
    if (!ctx) return;
    ctx.clearRect(0, 0, cv.width, cv.height);
    setFirmas(prev => ({ ...prev, [tipo === 'eval' ? 'evaluador' : 'evaluado']: undefined }));
  };

  const canvasTieneTrazos = (cv: HTMLCanvasElement | null): boolean => {
    if (!cv) return false;
    const ctx = cv.getContext('2d');
    if (!ctx) return false;
    // Un canvas "vacío" acá es todo blanco (lo pintamos con fillRect #fff).
    // Para no recorrer todo, muestreamos pixels y salimos temprano.
    try {
      const img = ctx.getImageData(0, 0, cv.width, cv.height);
      const data = img.data;
      const step = 4 * 25; // muestrear cada ~25 pixels
      for (let i = 0; i < data.length; i += step) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const a = data[i + 3];
        if (a !== 255 || r !== 255 || g !== 255 || b !== 255) return true;
      }
      return false;
    } catch {
      // Si por alguna razón no se puede leer (CORS/seguridad), asumir que no hay trazo.
      return false;
    }
  };

  const guardarFirmasDesdeCanvas = async () => { // convertir canvases a base64 y guardar
    if (!canvasTieneTrazos(canvasEvalRef.current)) {
      present({ message: 'La firma del evaluador está vacía.', duration: 2500, color: 'warning' });
      setFirmaPaso(1);
      return;
    }
    if (!canvasTieneTrazos(canvasEvadoRef.current)) {
      present({ message: 'La firma del evaluado está vacía.', duration: 2500, color: 'warning' });
      return;
    }

    const dataEval = canvasEvalRef.current?.toDataURL('image/png') || '';
    const dataEvado = canvasEvadoRef.current?.toDataURL('image/png') || '';
    const b64Eval = dataEval.split(',')[1] || '';
    const b64Evado = dataEvado.split(',')[1] || '';
    const firmasFinal = { evaluador: b64Eval, evaluado: b64Evado };
    setFirmas(firmasFinal);
    setMostrarModalFirmas(false);
    await guardarFinalConFirmas(firmasFinal);
  };

  const iniciarCanvas = (cv: HTMLCanvasElement | null) => { // configurar tamaño y estilo del canvas
    if (!cv) return;
    const ratio = window.devicePixelRatio || 1;
    const w = cv.clientWidth;
    const h = cv.clientHeight;
    cv.width = Math.max(1, Math.floor(w * ratio));
    cv.height = Math.max(1, Math.floor(h * ratio));
    const ctx = cv.getContext('2d');
    if (!ctx) return;
    // IMPORTANTE:
    // - Este método se llama varias veces (al abrir modal y al cambiar de paso).
    // - Si no reseteamos el transform, el ctx.scale() se acumula y en escritorio puede "romper" el dibujo.
    ctx.setTransform(1, 0, 0, 1, 0, 0); // resetear transform antes de escalar
    ctx.scale(ratio, ratio); // escalar una sola vez según devicePixelRatio

    // Pintar el fondo de blanco para que el área de firma se vea blanca
    // y para que el PNG exportado no quede con transparencia (que luego se ve rosado por el fondo del modal).
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, w, h);

    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.strokeStyle = '#000';
  };

  const initCanvasVisible = (pasoLocal: 1 | 2) => {
    // doble rAF: esperar layout + repaint (mejora estabilidad al abrir/animar IonModal)
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (pasoLocal === 1) iniciarCanvas(canvasEvalRef.current);
        if (pasoLocal === 2) iniciarCanvas(canvasEvadoRef.current);
      });
    });
  };

  const beginDraw = (tipo: 'eval' | 'evado', e: React.PointerEvent<HTMLCanvasElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const cv = tipo === 'eval' ? canvasEvalRef.current : canvasEvadoRef.current;
    if (!cv) return;
    const ctx = cv.getContext('2d'); if (!ctx) return;
    const rect = cv.getBoundingClientRect();
    ctx.beginPath();
    ctx.moveTo(e.clientX - rect.left, e.clientY - rect.top);
    setDibujando(prev => ({ ...prev, [tipo]: true }));
    (e.target as HTMLElement).setPointerCapture(e.pointerId);
  };
  const draw = (tipo: 'eval' | 'evado', e: React.PointerEvent<HTMLCanvasElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const isDrawing = tipo === 'eval' ? dibujando.eval : dibujando.evado; // verificar estado de dibujo
    if (!isDrawing) return;
    const cv = tipo === 'eval' ? canvasEvalRef.current : canvasEvadoRef.current;
    if (!cv) return;
    const ctx = cv.getContext('2d'); if (!ctx) return;
    const rect = cv.getBoundingClientRect();
    ctx.lineTo(e.clientX - rect.left, e.clientY - rect.top);
    ctx.stroke();
  };
  const endDraw = (tipo: 'eval' | 'evado') => {
    setDibujando(prev => ({ ...prev, [tipo]: false })); // marcar fin de dibujo para el tipo indicado
  };

  const onFirmaSiguiente = () => {
    if (!canvasTieneTrazos(canvasEvalRef.current)) {
      present({ message: 'La firma del evaluador está vacía.', duration: 2500, color: 'warning' });
      return;
    }
    setFirmaPaso(2);
    initCanvasVisible(2);
  };

  React.useEffect(() => { // detectar tipo de evaluación por query (?tipo=supervisor|operario) solo cuando es nuevo
    const qs = new URLSearchParams(location.search); // leer query string desde la URL
    const tipo = (qs.get('tipo') || 'operario').toLowerCase(); // leer tipo solicitado o asumir operario
    const evaluadorEsSupervisor = (evaluadorCargo || '').trim().toUpperCase() === 'SUPERVISOR'; // validar regla: supervisor solo evalúa operarios
    if (!qs.get('id')) { // si no estamos editando una evaluación existente
      // si el evaluador es SUPERVISOR, ignorar ?tipo=supervisor y forzar evaluación a operario
      setTipoEval(evaluadorEsSupervisor ? 'operario' : (tipo === 'supervisor' ? 'supervisor' : 'operario')); // aplicar regla de negocio
    }
  }, [location.search, evaluadorCargo]); // volver a evaluar cuando cambie la URL o se cargue el cargo del evaluador

  // Ajustar dinámicamente la longitud de arrays de respuestas según el tipo seleccionado
  React.useEffect(() => {
    const targetRespLen = tipoEval === 'supervisor' ? SUPERVISOR_RESP.length : OPERARIO_RESP.length; // longitud esperada para responsabilidades
    const targetHabLen  = tipoEval === 'supervisor' ? SUPERVISOR_HAB.length  : OPERARIO_HAB.length;  // longitud esperada para habilidades

    setRespuestasResp(prev => (prev.length === targetRespLen ? prev : Array(targetRespLen).fill(0))); // re-dimensionar si es necesario
    setRespuestasHab(prev => (prev.length === targetHabLen  ? prev : Array(targetHabLen).fill(0)));  // re-dimensionar si es necesario
  }, [tipoEval]);

  // establecer valor base 4 para el "Objetivo" de Capacitaciones cuando el tipo sea supervisor
  React.useEffect(() => { // efecto para setear el default del objetivo
    if (tipoEval !== 'supervisor') return; // aplicar solo para evaluaciones de supervisores
    setIndicSup(prev => { // actualizar el estado de indicadores de supervisor
      const curr = Number(prev.capacitaciones.objetivo || 0); // leer objetivo actual o 0 si está vacío
      if (!isFinite(curr) || curr < 1) { // si no es número válido o es menor a 1
        return { // devolver nuevo estado con el objetivo en 4
          ...prev, // mantener el resto de propiedades
          capacitaciones: { ...prev.capacitaciones, objetivo: "4" }, // setear "4" como base
        }; // fin objeto de retorno
      } // fin if
      return prev; // no modificar si el valor ya es válido
    }); // fin setIndicSup
  }, [tipoEval]); // dependemos del tipo de evaluación

  return ( // comenzar el JSX de la página
    <IonPage> {/* contenedor general de la página Ionic */}
      <Header titulo={tipoEval === 'supervisor' ? 'Evaluación de Desempeño - Supervisor' : 'Evaluación de Desempeño'} /> {/* encabezado de la página con título según tipo */}

      <IonContent id="evaluacion-de-desempeno" ref={contentRef}> {/* contenedor scrolleable con id único y referencia para scroll */}
        <div className="container mt-3"> {/* contenedor bootstrap con margen superior */}

          {/* Cabecera de datos de la evaluación */}
          <div className="card mb-3 shadow-sm"> {/* tarjeta de datos iniciales */}
            <div className="card-body p-2"> {/* cuerpo con padding */}
              <h6 className="mb-2" style={{ fontWeight: 600 }}>Datos de la evaluación</h6> {/* título */}
              <div className="row"> {/* fila para evaluado */}
                <div className="col-12 col-md-6"> {/* columna izquierda */}
                  <Autocompleteoperario // selector de evaluado (operario a evaluar)
                    label="Apellido y Nombre (Evaluado)" // etiqueta visible
                    value={evaluado} // valor actual del evaluado
                    setValue={onSeleccionarEvaluado} // manejador de cambio
                    filterCargo={null} // no filtrar por cargo: mostrar todos los operarios disponibles
                    tipoEvaluado={tipoEval === 'supervisor' ? 'SUPERVISOR' : 'OPERARIO'} // filtrar por tipo de evaluado (operarios con >6 meses; supervisores sin filtro de antigüedad)
                  /> {/* fin autocomplete */}
                </div>
                <div className="col-12 col-md-6"> {/* columna derecha */}
                  <IonItem lines="none"> {/* item de ion para fecha de ingreso */}
                    <IonLabel position="stacked">Fecha Ingreso a la empresa</IonLabel> {/* etiqueta apilada */}
                    <IonInput readonly value={fechaIngreso} placeholder="Se completará automáticamente al seleccionar el evaluado" /> {/* valor de fecha */}
                  </IonItem>
                </div>
              </div>

              <div className="row mt-1"> {/* fila para evaluador */}
                <div className="col-12 col-md-6"> {/* columna nombre evaluador */}
                  <IonItem lines="none"> {/* item */}
                    <IonLabel position="stacked">Nombre del Evaluador</IonLabel> {/* etiqueta */}
                    <IonInput readonly value={evaluadorNombre} placeholder="Desde sesión" /> {/* nombre */}
                  </IonItem>
                </div>
                <div className="col-12 col-md-6"> {/* columna cargo evaluador */}
                  <IonItem lines="none"> {/* item */}
                    <IonLabel position="stacked">Cargo del Evaluador</IonLabel> {/* etiqueta */}
                    <IonInput readonly value={evaluadorCargo} placeholder="Desde sesión" /> {/* cargo */}
                  </IonItem>
                </div>
              </div>
            </div>
          </div>

          {/* Sección 1: Responsabilidades del puesto y Desempeño */}
          {paso === 1 && (<div className="card mb-3 shadow-sm"> {/* tarjeta para la primera sección */}
            <div className="card-body p-2"> {/* cuerpo de la tarjeta con padding compacto */}
              <h6 className="mb-2" style={{ fontWeight: 600 }}> {/* título dentro del card */}
                Responsabilidades del puesto y Desempeño {/* texto del título */}
              </h6>
              <IonList> {/* lista mobile-friendly de preguntas */}
                {(tipoEval === 'supervisor' ? SUPERVISOR_RESP : OPERARIO_RESP).map((texto, i) => ( // iterar por preguntas según tipo
                  <div key={i} className="mb-2" style={{ border: '1px solid rgba(0,0,0,0.08)', borderRadius: 10, padding: 10 }}> {/* caja de pregunta */}
                    <IonItem lines="none"> {/* item sin línea inferior */}
                      <IonLabel className="ion-text-wrap"><strong>{i + 1}.) {texto}</strong></IonLabel> {/* texto de la pregunta */}
                    </IonItem>
                    <IonRadioGroup value={String(respuestasResp[i] || '')} onIonChange={(e) => setResp(i, Number(e.detail.value))}> {/* grupo de radios */}
                      {OPCIONES.map(op => ( // iterar por opciones
                        <IonItem key={op.label} lines="none"> {/* item de opción */}
                          <IonRadio slot="start" value={String(op.value)} /> {/* radio con valor */}
                          <IonLabel>{op.label}</IonLabel> {/* etiqueta de opción */}
                        </IonItem>
                      ))} {/* fin opciones */}
                    </IonRadioGroup>
                  </div>
                ))} {/* fin preguntas */}
              </IonList>
              <div className="d-flex flex-wrap justify-content-between mt-2"> {/* fila horizontal de métricas */}
                <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                  <small>Puntos alcanzados: <strong>{puntosResp}</strong></small> {/* valor alcanzado */}
                </div>
                <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                  <small>Puntos totales: <strong>{totalPosibleResp}</strong></small> {/* total posible */}
                </div>
                <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                  <small>Porcentaje: <strong>{fmt2(porcentajeResp)}%</strong></small> {/* porcentaje */}
                </div>
              </div>
              <div className="d-flex justify-content-end mt-2"> {/* navegación */}
                <IonButton
                  color="primary"
                  onClick={() => {
                    const completas = respuestasResp.every(v => v >= 1 && v <= 4); // verificar que todas las preguntas tengan valor 1..4
                    if (!completas) { // si falta alguna respuesta
                      present({ message: 'Completá todas las preguntas de Responsabilidades antes de continuar.', duration: 2500, color: 'warning' }); // mostrar advertencia
                      return; // no avanzar de paso
                    }
                    setPaso(2); // avanzar al siguiente paso
                    irArriba(); // llevar scroll al inicio
                  }}
                >
                  Siguiente
                </IonButton> {/* avanzar */}
              </div>
            </div>
          </div>)}

          {/* Sección 2: Habilidades */}
          {paso === 2 && (<div className="card mb-3 shadow-sm"> {/* tarjeta para habilidades */}
            <div className="card-body p-2"> {/* cuerpo de la tarjeta */}
              <h6 className="mb-2" style={{ fontWeight: 600 }}> {/* título dentro del card */}
                Habilidades {/* texto del título */}
              </h6>
              <IonList> {/* lista para preguntas de habilidades */}
                {(tipoEval === 'supervisor' ? SUPERVISOR_HAB : OPERARIO_HAB).map((texto, i) => ( // iterar por preguntas según tipo
                  <div key={i} className="mb-2" style={{ border: '1px solid rgba(0,0,0,0.08)', borderRadius: 10, padding: 10 }}> {/* caja */}
                    <IonItem lines="none"> {/* item */}
                      <IonLabel className="ion-text-wrap"><strong>{i + 1}.) {texto}</strong></IonLabel> {/* texto */}
                    </IonItem>
                    <IonRadioGroup value={String(respuestasHab[i] || '')} onIonChange={(e) => setHab(i, Number(e.detail.value))}> {/* radios */}
                      {OPCIONES.map(op => ( // opciones
                        <IonItem key={op.label} lines="none"> {/* item opción */}
                          <IonRadio slot="start" value={String(op.value)} /> {/* radio */}
                          <IonLabel>{op.label}</IonLabel> {/* etiqueta */}
                        </IonItem>
                      ))} {/* fin opciones */}
                    </IonRadioGroup>
                  </div>
                ))} {/* fin preguntas */}
              </IonList>
              <div className="d-flex flex-wrap justify-content-between mt-2"> {/* fila horizontal de métricas */}
                <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                  <small>Puntos alcanzados: <strong>{puntosHab}</strong></small> {/* valor */}
                </div>
                <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                  <small>Puntos totales: <strong>{totalPosibleHab}</strong></small> {/* valor */}
                </div>
                <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                  <small>Porcentaje: <strong>{fmt2(porcentajeHab)}%</strong></small> {/* valor */}
                </div>
              </div>
              <div className="d-flex justify-content-between mt-2"> {/* navegación */}
                <IonButton
                  color="medium"
                  onClick={() => {
                    setPaso(1); // retroceder
                    irArriba(); // llevar scroll al inicio
                  }}
                >
                  Anterior
                </IonButton> {/* retroceder */}
                <IonButton
                  color="primary"
                  onClick={() => {
                    const completas = respuestasHab.every(v => v >= 1 && v <= 4); // verificar que todas las habilidades estén respondidas
                    if (!completas) { // si falta alguna
                      present({ message: 'Completá todas las preguntas de Habilidades antes de continuar.', duration: 2500, color: 'warning' }); // advertencia
                      return; // no avanzar
                    }
                    setPaso(3); // avanzar al siguiente paso
                    irArriba(); // llevar scroll al inicio
                  }}
                >
                  Siguiente
                </IonButton> {/* avanzar */}
              </div>
            </div>
          </div>)}

          {/* Sección 3: Indicadores de Gestión (Operario) */}
          {paso === 3 && tipoEval !== 'supervisor' && (<div className="card mb-3 shadow-sm"> {/* tarjeta indicadores operario */}
            <div className="card-header bg-em-red text-white"> {/* encabezado */}
              Indicadores de Gestión {/* título */}
            </div>
            <div className="card-body p-2"> {/* cuerpo */}
              <IonList> {/* lista de indicadores fija */}
                <div className="mb-2" style={{ border: '1px solid rgba(0,0,0,0.08)', borderRadius: 10, padding: 10 }}>
                  <IonItem lines="none">
                    <IonLabel className="ion-text-wrap"><strong>Cantidad de sanciones en el periodo</strong></IonLabel>
                  </IonItem>
                  <IonItem lines="none">
                    <IonLabel position="stacked">Cantidad</IonLabel>
                    <IonInput
                      type="number" // tipo numérico
                      readonly // solo lectura: valor autocompletado por la API
                      value={(indicOper as any)?.sanciones || ""} // mostrar cantidad autocompletada
                      placeholder="0" // placeholder por defecto
                    />
                  </IonItem>
                  <div className="d-flex flex-wrap justify-content-between mt-1">
                    <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                      <small>Puntos: <strong>{(() => { const n = Number((indicOper as any)?.sanciones || 0); return n === 0 ? 3 : n === 1 ? 2 : n === 2 ? 1 : 0; })()}</strong></small>
                    </div>
                  </div>
                </div>
              </IonList>
              <div className="d-flex flex-wrap justify-content-between mt-2"> {/* fila totales */}
                <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                  <small>Puntos alcanzados: <strong>{fmt2(puntosIndic)}</strong></small> {/* valor */}
                </div>
                <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                  <small>Puntos totales: <strong>{totalPosibleIndic}</strong></small> {/* valor */}
                </div>
                <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                  <small>Porcentaje: <strong>{fmt2(porcentajeIndic)}%</strong></small> {/* valor */}
                </div>
              </div>
              <div className="d-flex justify-content-between mt-2"> {/* navegación */}
                <IonButton
                  color="medium"
                  onClick={() => {
                    setPaso(2); // retroceder al paso de habilidades
                    irArriba(); // llevar scroll al inicio
                  }}
                >
                  Anterior
                </IonButton> {/* retroceder */}
                <IonButton
                  color="primary"
                  onClick={() => {
                    // para operario, los indicadores se autocompletan y son de solo lectura:
                    // no se requiere validación adicional para continuar
                    setPaso(4); // avanzar al resumen
                    irArriba(); // llevar scroll al inicio
                  }}
                >
                  Siguiente
                </IonButton> {/* avanzar */}
              </div>
            </div>
          </div>)}

          {/* Sección 3: Indicadores de Gestión (Supervisor) */}
          {paso === 3 && tipoEval === 'supervisor' && (<div className="card mb-3 shadow-sm"> {/* tarjeta indicadores supervisor */}
            <div className="card-header bg-em-red text-white"> {/* encabezado */}
              Indicadores de Gestión {/* título */}
            </div>
            <div className="card-body p-2"> {/* cuerpo */}
              <IonList>
                <div className="mb-2" style={{ border: '1px solid rgba(0,0,0,0.08)', borderRadius: 10, padding: 10 }}> {/* único indicador de capacitaciones */}
                  <IonItem lines="none">
                    <IonLabel className="ion-text-wrap"><strong>Cantidad de capacitaciones realizadas en el periodo</strong></IonLabel>
                  </IonItem>
                  <div className="row">
                    <div className="col-6">
                      <IonItem lines="none">
                        <IonLabel position="stacked">Objetivo</IonLabel>
                        <IonInput
                          type="number" // definir tipo numérico
                          value={indicSup.capacitaciones.objetivo} // valor actual del objetivo
                          placeholder="4" // mostrar 4 como base por defecto
                          onIonChange={(e) => setIndicadorSupervisor("objetivo", String(e.detail.value))} // actualizar al escribir
                          onIonBlur={() => { // al salir del campo validar el valor
                            const n = Number(indicSup.capacitaciones.objetivo); // convertir a número
                            if (!isFinite(n) || n < 1) { // si no es válido o es menor que 1
                              setIndicadorSupervisor("objetivo", "4"); // reponer 4 como base
                            } // fin if
                          }} // fin onBlur
                        />
                      </IonItem>
                    </div>
                    <div className="col-6">
                      <IonItem lines="none">
                        <IonLabel position="stacked">Cantidad</IonLabel>
                        <IonInput type="number" value={indicSup.capacitaciones.cantidad} placeholder="0" onIonChange={(e) => setIndicadorSupervisor("cantidad", String(e.detail.value))} />
                      </IonItem>
                    </div>
                  </div>
                  <div className="d-flex flex-wrap justify-content-between mt-1">
                    <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                      <small>Porcentaje: <strong>{fmt2(indicSupCalc.capacitaciones.porcentaje)}%</strong></small>
                    </div>
                    <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                      <small>Puntuación: <strong>{fmt2(indicSupCalc.capacitaciones.puntuacion)}</strong></small>
                    </div>
                  </div>
                </div>
              </IonList>
              <div className="d-flex flex-wrap justify-content-between mt-2">
                <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                  <small>Puntos alcanzados: <strong>{fmt2(puntosIndic)}</strong></small>
                </div>
                <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                  <small>Puntos totales: <strong>{totalPosibleIndic}</strong></small>
                </div>
                <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                  <small>Porcentaje: <strong>{fmt2(porcentajeIndic)}%</strong></small>
                </div>
              </div>
              <div className="d-flex justify-content-between mt-2">
                <IonButton
                  color="medium"
                  onClick={() => {
                    setPaso(2); // volver al paso de habilidades
                    irArriba(); // llevar scroll al inicio
                  }}
                >
                  Anterior
                </IonButton>
                <IonButton
                  color="primary"
                  onClick={() => {
                    const obj = Number(indicSup.capacitaciones.objetivo || 0); // objetivo de capacitaciones
                    const can = Number(indicSup.capacitaciones.cantidad || 0); // cantidad de capacitaciones
                    if (!(obj > 0) || can < 0) { // validar objetivo > 0 y cantidad no negativa
                      present({ message: 'Completá los indicadores de capacitaciones (objetivo > 0 y cantidad >= 0) antes de continuar.', duration: 2500, color: 'warning' }); // advertencia
                      return; // no avanzar
                    }
                    setPaso(4); // avanzar al resumen
                    irArriba(); // llevar scroll al inicio
                  }}
                >
                  Siguiente
                </IonButton>
              </div>
            </div>
          </div>)}
          {/* Sección 4: Selección múltiple (Fortalezas, Oportunidades, Capacitaciones) */}
          {paso === 4 && (<div className="card mb-3 shadow-sm"> {/* tarjeta selección múltiple */}
            <div className="card-header bg-em-red text-white"> {/* encabezado */}
              Resúmenes (selección múltiple, hasta 5 por sección) {/* título */}
            </div>
            <div className="card-body p-2"> {/* cuerpo */}

              {/* Bloque: Fortalezas */}
              <div className="mb-3" style={{ border: '1px solid rgba(0,0,0,0.08)', borderRadius: 10, padding: 10 }}> {/* caja fortalezas */}
              <div className="d-flex align-items-center justify-content-between mb-1">
                  <strong>Principales fortalezas del colaborador/a</strong> {/* título */}
                  <small className="text-muted">{fortalezasSel.length + (fortalezasOtra ? 1 : 0)}/{tipoEval === 'operario' ? 3 : 5}</small> {/* contador dinámico */}
                </div>
                <IonList> {/* lista de opciones */}
                  {FORTALEZAS_OPCIONES.map(op => { // iterar por opciones
                    const selected = fortalezasSel.includes(op.id); // saber si está seleccionado
                    const maxSel = tipoEval === 'operario' ? 3 : 5; // máximo por tipo según estado
                    const cant = fortalezasSel.length + (fortalezasOtra ? 1 : 0); // total contando "Otra"
                    const disabled = !selected && cant >= maxSel; // deshabilitar si ya se alcanzó el tope
                    return (
                      <IonItem key={op.id} lines="none"> {/* item */}
                        <IonCheckbox
                          checked={selected} // estado del checkbox
                          disabled={disabled} // deshabilitar si se llegó al máximo
                          onIonChange={(e) => { // toggle de selección
                            const checked = Boolean(e.detail.checked); // valor nuevo
                            setFortalezasSel(prev => checked ? [...prev, op.id] : prev.filter(id => id !== op.id)); // agregar o quitar
                          }}
                        />
                        <IonLabel className="ion-text-wrap" style={{ marginLeft: 8 }}>{op.label}</IonLabel> {/* etiqueta */}
                      </IonItem>
                    );
                  })}
                  <IonItem lines="none"> {/* opción Otra */}
                    <IonCheckbox
                      checked={fortalezasOtra} // estado de "Otra"
                      disabled={!fortalezasOtra && (fortalezasSel.length + (fortalezasOtra ? 1 : 0)) >= (tipoEval === 'operario' ? 3 : 5)} // respeta el máximo según tipo actual
                      onIonChange={(e) => setFortalezasOtra(Boolean(e.detail.checked))} // marcar/desmarcar
                    />
                    <IonLabel style={{ marginLeft: 8 }}>Otra</IonLabel> {/* etiqueta */}
                  </IonItem>
                  {fortalezasOtra && (
                    <IonItem lines="none"> {/* input de Otra */}
                      <IonLabel position="stacked">Describa la otra fortaleza</IonLabel> {/* etiqueta */}
                      <IonInput value={fortalezasOtraTxt} placeholder="Especifique..." onIonChange={(e) => setFortalezasOtraTxt(String(e.detail.value || ""))} /> {/* input */}
                    </IonItem>
                  )}
                </IonList>
              </div>

              {/* Bloque: Oportunidades */}
              <div className="mb-3" style={{ border: '1px solid rgba(0,0,0,0.08)', borderRadius: 10, padding: 10 }}> {/* caja oportunidades */}
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <strong>Oportunidades de mejora</strong> {/* título */}
                  <small className="text-muted">{oportSel.length + (oportOtra ? 1 : 0)}/{tipoEval === 'operario' ? 3 : 5}</small> {/* contador */}
                </div>
                <IonList> {/* lista */}
                  {OPORTUNIDADES_OPCIONES.map(op => { // iterar opciones
                    const selected = oportSel.includes(op.id); // seleccionado
                    const maxSel = tipoEval === 'operario' ? 3 : 5; // máximo según tipo actual
                    const cant = oportSel.length + (oportOtra ? 1 : 0); // total con "Otra"
                    const disabled = !selected && cant >= maxSel; // tope
                    return (
                      <IonItem key={op.id} lines="none"> {/* item */}
                        <IonCheckbox
                          checked={selected} // estado
                          disabled={disabled} // tope
                          onIonChange={(e) => { // toggle
                            const checked = Boolean(e.detail.checked); // nuevo valor
                            setOportSel(prev => checked ? [...prev, op.id] : prev.filter(id => id !== op.id)); // agregar/quitar
                          }}
                        />
                        <IonLabel className="ion-text-wrap" style={{ marginLeft: 8 }}>{op.label}</IonLabel> {/* etiqueta */}
                      </IonItem>
                    );
                  })}
                  <IonItem lines="none"> {/* Otra */}
                    <IonCheckbox
                      checked={oportOtra} // estado
                      disabled={!oportOtra && (oportSel.length + (oportOtra ? 1 : 0)) >= (tipoEval === 'operario' ? 3 : 5)} // tope según tipo actual
                      onIonChange={(e) => setOportOtra(Boolean(e.detail.checked))} // toggle
                    />
                    <IonLabel style={{ marginLeft: 8 }}>Otra</IonLabel> {/* etiqueta */}
                  </IonItem>
                  {oportOtra && (
                    <IonItem lines="none"> {/* input */}
                      <IonLabel position="stacked">Describa la otra oportunidad de mejora</IonLabel> {/* etiqueta */}
                      <IonInput value={oportOtraTxt} placeholder="Especifique..." onIonChange={(e) => setOportOtraTxt(String(e.detail.value || ""))} /> {/* input */}
                    </IonItem>
                  )}
                </IonList>
              </div>

              {/* Bloque: Capacitaciones */}
              <div className="mb-1" style={{ border: '1px solid rgba(0,0,0,0.08)', borderRadius: 10, padding: 10 }}> {/* caja capacitaciones */}
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <strong>Sugerencias de Capacitaciones</strong> {/* título */}
                  <small className="text-muted">{capSel.length + (capOtra ? 1 : 0)}/{tipoEval === 'operario' ? 3 : 5}</small> {/* contador */}
                </div>
                <IonList> {/* lista */}
                  {CAPACITACIONES_OPCIONES.map(op => { // iterar opciones
                    const selected = capSel.includes(op.id); // seleccionado
                    const maxSel = tipoEval === 'operario' ? 3 : 5; // máximo según tipo actual
                    const cant = capSel.length + (capOtra ? 1 : 0); // total con "Otra"
                    const disabled = !selected && cant >= maxSel; // tope
                    return (
                      <IonItem key={op.id} lines="none"> {/* item */}
                        <IonCheckbox
                          checked={selected} // estado
                          disabled={disabled} // tope
                          onIonChange={(e) => { // toggle
                            const checked = Boolean(e.detail.checked); // valor
                            setCapSel(prev => checked ? [...prev, op.id] : prev.filter(id => id !== op.id)); // agregar/quitar
                          }}
                        />
                        <IonLabel className="ion-text-wrap" style={{ marginLeft: 8 }}>{op.label}</IonLabel> {/* etiqueta */}
                      </IonItem>
                    );
                  })}
                  <IonItem lines="none"> {/* Otra */}
                    <IonCheckbox
                      checked={capOtra} // estado
                      disabled={!capOtra && (capSel.length + (capOtra ? 1 : 0)) >= (tipoEval === 'operario' ? 3 : 5)} // tope según tipo actual
                      onIonChange={(e) => setCapOtra(Boolean(e.detail.checked))} // toggle
                    />
                    <IonLabel style={{ marginLeft: 8 }}>Otra</IonLabel> {/* etiqueta */}
                  </IonItem>
                  {capOtra && (
                    <IonItem lines="none"> {/* input */}
                      <IonLabel position="stacked">Describa la otra capacitación sugerida</IonLabel> {/* etiqueta */}
                      <IonInput value={capOtraTxt} placeholder="Especifique..." onIonChange={(e) => setCapOtraTxt(String(e.detail.value || ""))} /> {/* input */}
                    </IonItem>
                  )}
                </IonList>
              </div>

            </div>
          </div>)}

          {/* Sección 4: Competencias Requeridas */}
          {paso === 4 && (<div className="card mb-3 shadow-sm"> {/* tarjeta competencias */}
            <div className="card-header bg-em-red text-white"> {/* encabezado */}
              Competencias Requeridas {/* título */}
            </div>
            <div className="card-body p-2"> {/* cuerpo */}
              <div className="row"> {/* disposición en tarjetas apiladas para móvil */}
                <div className="col-12 mb-2"> {/* tarjeta responsabilidad */}
                  <div style={{ border: '1px solid rgba(0,0,0,0.08)', borderRadius: 10, padding: 10 }}> {/* caja */}
                    <div className="d-flex align-items-center mb-1"><strong>Responsabilidad en el cargo</strong></div> {/* título */}
                    <div className="d-flex flex-wrap justify-content-between"> {/* valores en píldoras */}
                      <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                        <small>Totales: <strong>{totalPosibleResp}</strong></small> {/* total */}
                      </div>
                      <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                        <small>Alcanzados: <strong>{puntosResp}</strong></small> {/* alcanzados */}
                      </div>
                      <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                        <small>Porcentaje: <strong>{fmt2(porcentajeResp)}%</strong></small> {/* porcentaje */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 mb-2"> {/* tarjeta habilidades */}
                  <div style={{ border: '1px solid rgba(0,0,0,0.08)', borderRadius: 10, padding: 10 }}> {/* caja */}
                    <div className="d-flex align-items-center mb-1"><strong>Habilidades</strong></div> {/* título */}
                    <div className="d-flex flex-wrap justify-content-between"> {/* valores en píldoras */}
                      <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                        <small>Totales: <strong>{totalPosibleHab}</strong></small> {/* total */}
                      </div>
                      <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                        <small>Alcanzados: <strong>{puntosHab}</strong></small> {/* alcanzados */}
                      </div>
                      <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                        <small>Porcentaje: <strong>{fmt2(porcentajeHab)}%</strong></small> {/* porcentaje */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12"> {/* tarjeta indicadores */}
                  <div style={{ border: '1px solid rgba(0,0,0,0.08)', borderRadius: 10, padding: 10 }}> {/* caja */}
                    <div className="d-flex align-items-center mb-1"><strong>Indicadores de gestión</strong></div> {/* título */}
                    <div className="d-flex flex-wrap justify-content-between"> {/* valores en píldoras */}
                      <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                        <small>Totales: <strong>{totalPosibleIndic}</strong></small> {/* total */}
                      </div>
                      <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                        <small>Alcanzados: <strong>{fmt2(puntosIndic)}</strong></small> {/* alcanzados */}
                      </div>
                      <div className="mb-1" style={{ background: '#f5f5f5', padding: '6px 10px', borderRadius: 8 }}>
                        <small>Porcentaje: <strong>{fmt2(porcentajeIndic)}%</strong></small> {/* porcentaje */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>)}

          {/* Puntaje Final */}
          {paso === 4 && (<div className="card mb-4 shadow-sm"> {/* tarjeta final */}
            <div className="card-header bg-em-red text-white"> {/* encabezado */}
              Puntaje total final {/* título */}
            </div>
            <div className="card-body"> {/* cuerpo */}
              <div className="d-flex flex-wrap justify-content-between"> {/* fila en píldoras */}
                <div className="mb-1" style={{ background: '#f5f5f5', padding: '8px 12px', borderRadius: 8 }}>
                  <small>Puntos Totales: <strong>{puntajeFinal.total}</strong></small> {/* total */}
                </div>
                <div className="mb-1" style={{ background: '#f5f5f5', padding: '8px 12px', borderRadius: 8 }}>
                  <small>Puntos Alcanzados: <strong>{fmt2(puntajeFinal.alcanzado)}</strong></small> {/* alcanzado */}
                </div>
                <div className="mb-1" style={{ background: '#f5f5f5', padding: '8px 12px', borderRadius: 8 }}>
                  <small>Porcentaje Final: <strong>{fmt2(puntajeFinal.porcentaje)}%</strong></small> {/* porcentaje */}
                </div>
              </div>

              <div className="d-flex justify-content-between mt-2 flex-wrap"> {/* acciones */}
                <IonButton color="medium" onClick={() => setPaso(3)}>Anterior</IonButton> {/* retroceder */}
                <div className="d-flex">
                  <IonButton
                    color="medium"
                    fill="outline"
                    onClick={onGuardarBorrador}
                    disabled={!puedeGuardarBorrador}
                    className="mr-2"
                  >
                    Guardar en Proceso
                  </IonButton> {/* guardar como EN_PROCESO */}
                  <IonButton color="primary" onClick={onGuardar} disabled={!puedeGuardar}> {/* botón finalizar */}
                    Finalizar
                  </IonButton>
                </div>
              </div> {/* fin acciones */}
            </div>
          </div>)}

          {/* Modal de firmas */}
          <IonModal
            isOpen={mostrarModalFirmas}
            onDidPresent={() => initCanvasVisible(firmaPaso)}
            onDidDismiss={() => { setMostrarModalFirmas(false); setFirmaPaso(1); }}
          >
            <IonPage>
              <IonHeader>
                <IonToolbar color="primary">
                  <IonTitle style={{ textAlign: 'center' }}>{firmaPaso === 1 ? 'Firma Evaluador' : 'Firma Evaluado'}</IonTitle>
                </IonToolbar>
              </IonHeader>

              {/*
                Importante:
                - En Ionic, para que Header/Content/Footer se posicionen correctamente dentro de un Modal,
                  el contenido debe estar envuelto en un IonPage.
                - Así el Footer queda fijo abajo y siempre visible en escritorio.
              */}
              <IonContent>
                {/*
                  Nota de UX (desktop):
                  - En algunos modos/temas, IonFooter dentro de IonModal no se ve por recortes del modal.
                  - Usamos slot="fixed" dentro de IonContent para asegurar que los botones siempre queden visibles.
                  - Se agrega padding inferior al contenido para que el canvas no quede tapado.
                */}
                <div className="container ion-padding" style={{ paddingBottom: 72 }}>
                  <div className="row">
                    <div className="col-12 mb-3">
                      {/* Contenedor visible SOLO para firma del evaluador */}
                      <div
                        className="firma-box"
                        style={{
                          border: '1px solid #ccc', // borde visible del recuadro
                          borderRadius: 6, // esquinas redondeadas
                          background: '#fff', // fondo blanco para resaltar el área de firma
                          maxWidth: '700px', // limitar ancho en pantallas grandes
                          margin: '0 auto', // centrar horizontalmente
                          height: '60vh', // más grande en móvil
                          minHeight: 280, // evitar que quede demasiado chico
                          maxHeight: 520, // evitar que tape el footer
                          display: firmaPaso === 1 ? 'block' : 'none', // visible solo en la firma del evaluador
                        }}
                      >
                        <canvas
                          ref={canvasEvalRef}
                          className="firma-canvas" // canvas ocupa todo el recuadro
                          style={{ width: '100%', height: '100%', display: 'block', touchAction: 'none' }}
                          onPointerDown={(e) => firmaPaso === 1 && beginDraw('eval', e)}
                          onPointerMove={(e) => firmaPaso === 1 && draw('eval', e)}
                          onPointerUp={() => firmaPaso === 1 && endDraw('eval')}
                          onPointerLeave={() => firmaPaso === 1 && endDraw('eval')}
                        />
                      </div>

                      {/* Contenedor visible SOLO para firma del evaluado */}
                      <div
                        className="firma-box"
                        style={{
                          border: '1px solid #ccc', // borde visible del recuadro
                          borderRadius: 6, // esquinas redondeadas
                          background: '#fff', // fondo blanco para resaltar el área de firma
                          maxWidth: '700px', // límite de ancho en escritorio
                          margin: '16px auto 0 auto', // centrar horizontalmente y separar de la parte superior
                          height: '60vh', // más grande en móvil
                          minHeight: 280, // evitar que quede demasiado chico
                          maxHeight: 520, // evitar que tape el footer
                          display: firmaPaso === 2 ? 'block' : 'none', // visible solo en la firma del evaluado
                        }}
                      >
                        <canvas
                          ref={canvasEvadoRef}
                          className="firma-canvas" // canvas ocupa todo el recuadro
                          style={{ width: '100%', height: '100%', display: 'block', touchAction: 'none' }}
                          onPointerDown={(e) => firmaPaso === 2 && beginDraw('evado', e)}
                          onPointerMove={(e) => firmaPaso === 2 && draw('evado', e)}
                          onPointerUp={() => firmaPaso === 2 && endDraw('evado')}
                          onPointerLeave={() => firmaPaso === 2 && endDraw('evado')}
                        />
                      </div>

                      <div className="d-flex mt-1">
                        {firmaPaso === 1 ? (
                          <IonButton size="small" color="medium" onClick={() => limpiarFirma('eval')}>Limpiar</IonButton>
                        ) : (
                          <IonButton size="small" color="medium" onClick={() => limpiarFirma('evado')}>Limpiar</IonButton>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  slot="fixed"
                  style={{
                    left: 0,
                    right: 0,
                    bottom: 0,
                    padding: '10px 12px',
                    background: '#fff',
                    borderTop: '1px solid rgba(0,0,0,0.12)',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 8,
                    zIndex: 10,
                  }}
                >
                  <IonButton color="medium" onClick={() => setMostrarModalFirmas(false)}>Cancelar</IonButton>
                  {firmaPaso === 1 ? (
                    <IonButton color="primary" onClick={onFirmaSiguiente}>Siguiente</IonButton>
                  ) : (
                    <IonButton color="primary" onClick={guardarFirmasDesdeCanvas}>Guardar</IonButton>
                  )}
                </div>
              </IonContent>
            </IonPage>
          </IonModal>

        </div>
      </IonContent>
    </IonPage>
  ); // fin JSX
}; // fin componente

export default EvaluacionDesempeno; // exportar componente


